import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";
import { toast } from "react-toastify";

const Sampletext = () => {
  const [list, setList] = useState([]);

  const fetchBanners = async () => {
    try {
      const res = await fetch(getApiUrl("banner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      const result = await res.json();

      if (result.success) {
        setList(result.data);
      } else {
        toast.error(result.message || "Failed to fetch");
      }
    } catch (err) {
      toast.error("Server error");
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
    <div className="ad-container">
      <div className="ad-track">
        {list.map((item) =>
          item.advertisementDescription?.map((text, index) => (
            <span className="ad-item" key={item._id + index}>
              {text}
            </span>
          ))
        )}
      </div>
    </div>
  );
};

export default Sampletext;
